import React, { useState, useEffect } from "react";
import {
    Box,
    Grid,
    Button,
    TextField,
    Typography,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Autocomplete,
} from "@mui/material";
import { FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import {
    Payment as PaymentIcon,
    AccountBalance as AccountBalanceIcon,
    CreditCard as CreditCardIcon,
    Public as PublicIcon,
} from "@mui/icons-material";
import PaymentsIcon from "@mui/icons-material/Payments";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import axios from "../../../lib/axios";
import CustomAutocomplete from '../../../Components/AutoComplete/AutoComplete';
import axiosInstance from "../../../lib/axios";

const RefundStep1 = ({
    onResidentsLoad,
    AllTextDisabled,
    AllButtonDisabled,
    setAllButtonDisabled,
    formData,
    setFormData,
    handleCancel,
    fetchRefundData,
    PytId,
    handleStepClick,
    setPytId,
}) => {
    const [bankData, setBankData] = useState([]);
    const [residents, setResidents] = useState([]);
    const [propertyData, setPropertyData] = useState([]);
    const [docData, setDocData] = useState([]);
    const navigate = useNavigate();
    const currentDate = new Date().toISOString().split("T")[0];
    const UserId = sessionStorage.getItem('UserId');
console.log('formData',formData)
    useEffect(() => {
        if (!formData.Pyttype) {
            setFormData((prevState) => ({
                ...prevState,
                Pyttype: "Cash",
            }));
        }
    }, [formData, setFormData]);

    useEffect(() => {
        if (formData.Pyttype === "Cash" && bankData.length > 0) {
            setFormData((prevState) => ({
                ...prevState,
                AccLedId: 1,
            }));
        }
    }, [formData.Pyttype, bankData, setFormData]);

    const handleFieldChange = (field) => (event) => {
        const { value } = event.target;
        setFormData({
            ...formData,
            [field]: value,
        });
    };

    useEffect(() => {
        const fetchPropertyData = async () => {
            try {
                const response = await axios.post(
                    `PropertyMst/GetPropertyMstUserwisedrp`,
                    {
                        UserId,
                        Flag: ""
                    }
                );
                if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                    setPropertyData(response.data.Data);
                    if (response.data.Data.length > 0 && !formData.PropId) {
                        setFormData((prevState) => ({
                            ...prevState,
                            PropId: response.data.Data[0].Id.toString(),
                        }));
                    }
                } else {
                    toast.error('Failed to fetch Property');
                }
            } catch (error) {
                toast.error('Error fetching Property. Please try again.');
            }
        };

        fetchPropertyData();
    }, [formData.PropId, setFormData]);

    useEffect(() => {
        const fetchResident = async () => {
            try {
                const response = await axiosInstance.post("ResidentMst/getAllResidentMstDashBoard", {
                    start: 1,
                    PageSize: 1,
                    SearchText: "drp",
                });
                if (response && response.data && Array.isArray(response.data.Data)) {
                    setResidents(response.data.Data);
                    onResidentsLoad(response.data.Data);
                } else {
                    toast.info("No residents data found or invalid response format");
                }
            } catch (error) {
                toast.error("Error while fetching resident");
            }
        };
        fetchResident();
    }, []);

    useEffect(() => {
        const fetchBankDetails = async () => {
            try {
                const response = await axiosInstance.post("MstBank/getMstBankdrp");
                if (response && response.data && Array.isArray(response.data.Data)) {
                    setBankData(response.data.Data);
                } else {
                    toast.info("No bank data found or invalid response format");
                }
            } catch (error) {
                toast.error("Error while fetching bank dropdown");
            }
        };
        fetchBankDetails();
    }, []);

    useEffect(() => {
        const fetchDocument = async () => {
            try {
                let response = await axiosInstance.post('TrnChkOutStl/getTrnChkOutStldrp', {
                    Flag: "",
                    ResidentId: 10352,
                    BookId: 1
                });
                if (response.data.Status === 0 && Array.isArray(response.data.Data)) {
                    setDocData(response.data.Data);
                }
            } catch (error) {
                toast.error("Error while ")
            }
        };
        fetchDocument();
    }, [])

    const handleInputChange = (event, newValue) => {
        if (event && event.target) {
            const { name, value } = event.target;
            setFormData({
                ...formData,
                [name]: name === "PytAmt" ? parseFloat(value) || 0 : value,
            });
        } else if (newValue) {
            setFormData({
                ...formData,
                ChkOutStlNo: newValue.ChkOutStlNo,
                ChkOutStlId: newValue.ChkOutStlId.toString(),
                PropId: newValue.PropId,
                PytVchrRef: newValue.Name,
            });
        } else {
            setFormData({
                ...formData,
                ChkOutStlNo: "",
                ChkOutStlId: "",
            });
        }
    };

    const handleRadioChange = (name, value) => {
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleNextButtonClick = () => {
        const missingFields = [];
        if (formData.Pyttype === "Bank" || formData.Pyttype === "Card" || formData.Pyttype === "RTGS/NEFT") {
            if (!formData.BankName) missingFields.push("Customer Bank");
            if (!formData.ChequeNo) missingFields.push("Cheque No/Transaction Id");
            if (!formData.AccLedId) missingFields.push("Our Bank/Ledger");
        }
        if (!formData.ResidentId) missingFields.push("Resident/Corporate");
        if (!formData.PropId || formData.PropId === "") missingFields.push("Property");
        if (missingFields.length > 0) {
            const missingFieldsMessage = missingFields.join(", ");
            toast.error(`Please fill the mandatory fields: ${missingFieldsMessage}.`);
            return;
        }
        handleStepClick(1);
    };

    useEffect(() => {
        if (formData.PytAmt && formData.AgstBill) {
            const onacAmt = parseFloat(formData.PytAmt) - parseFloat(formData.AgstBill);
            setFormData((prevData) => ({
                ...prevData,
                OnacAmt: isNaN(onacAmt) ? "" : onacAmt?.toFixed(2),
            }));
        }
    }, [formData.PytAmt, formData.AgstBill, setFormData]);

    return (
        <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} md={10}>
                <Box display="flex" flexDirection="column" gap={1}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6} md={4}>
                            <CustomAutocomplete
                                options={propertyData}
                                id="PropId-autocomplete"
                                name="PropId"
                                label={
                                    <span>
                                        Property<span style={{ color: "red" }}>*</span>
                                    </span>
                                }
                                value={propertyData.find((prop) => prop.Id === parseInt(formData.PropId)) || null}
                                onChange={handleInputChange}
                                disabled={AllTextDisabled}
                                getOptionLabel={(option) => option.Name || ""}
                                isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                variant='filled'
                                className='custom-textfield'
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                value={formData.PytNo || ""}
                                label="Payment No"
                                variant="filled"
                                className="custom-textfield"
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label="Payment Date"
                                name="PytDt"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                variant="filled"
                                className="custom-textfield"
                                disabled={AllTextDisabled}
                                value={formData.PytDt ? moment(formData.PytDt).format("YYYY-MM-DD") : currentDate}
                                onChange={handleInputChange}
                                InputProps={{
                                    inputProps: {
                                        max: currentDate,
                                    },
                                }}
                            />
                        </Grid>

                        {/* Resident/Corporate, Resident Mobile, Ref_No */}
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl variant="filled" fullWidth className="custom-select">
                                <Autocomplete
                                    id="ResidentId"
                                    name="ResidentId"
                                    value={residents.find((resident) => resident.ResidentId === formData.ResidentId) || null}
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            handleFieldChange("ResidentId")({ target: { value: newValue.ResidentId } });
                                        }
                                    }}
                                    options={residents}
                                    getOptionLabel={(option) => `${option.Name}`}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={<>Resident/Corporate <span style={{ color: "red" }}>*</span></>}
                                            variant="filled"
                                            fullWidth
                                        />
                                    )}
                                    disabled={AllTextDisabled}
                                    className="custom-textfield"
                                    isOptionEqualToValue={(option, value) => option.ResidentId === value.ResidentId}
                                    disableClearable
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl variant="filled" fullWidth className="custom-select">
                                <Autocomplete
                                    id="ResidentMobile"
                                    name="ResidentMobile"
                                    value={residents.find((resident) => resident.ResidentId === formData.ResidentId) || null}
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            handleFieldChange("ResidentId")({ target: { value: newValue.ResidentId } });
                                        }
                                    }}
                                    options={residents}
                                    getOptionLabel={(option) => `${option.Mobile}`}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Mobile" variant="filled" fullWidth />
                                    )}
                                    disabled={AllTextDisabled}
                                    className="custom-textfield"
                                    isOptionEqualToValue={(option, value) => option.ResidentId === value.ResidentId}
                                    disableClearable
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label={<span>Ref No</span>}
                                name="PytVchrRef"
                                variant="filled"
                                className="custom-textfield"
                                disabled={AllTextDisabled}
                                value={formData.PytVchrRef || ""}
                                onChange={handleInputChange}
                            />
                        </Grid>

 
                        <Grid item xs={12}>
                            <Grid container alignItems="center" spacing={1}>
                                <Grid item>
                                    <FormLabel component="legend">Payment Method</FormLabel>
                                </Grid>
                                <Grid item>
                                    <FormControl component="fieldset">
                                        <RadioGroup
                                            aria-label="Pyttype"
                                            name="Pyttype"
                                            onChange={(e) => handleRadioChange("Pyttype", e.target.value)}
                                            value={formData.Pyttype || "Cash"}
                                            row
                                        >
                                            <FormControlLabel
                                                value="Cash"
                                                control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                                                label={
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <PaymentsIcon
                                                            sx={{
                                                                fontSize: 18,
                                                                marginRight: 0.2,
                                                                marginLeft: 0,
                                                                opacity: 0.7,
                                                                color: "rgba(0, 0, 0, 0.5)",
                                                            }}
                                                        />
                                                        Cash
                                                    </div>
                                                }
                                                className="custom-textfield"
                                                disabled={AllTextDisabled}
                                            />
                                            <FormControlLabel
                                                value="Bank"
                                                control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                                                label={
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <AccountBalanceIcon
                                                            sx={{
                                                                fontSize: 18,
                                                                marginRight: 0.2,
                                                                marginLeft: 0,
                                                                opacity: 0.7,
                                                                color: "rgba(0, 0, 0, 0.5)",
                                                            }}
                                                        />
                                                        Bank
                                                    </div>
                                                }
                                                className="custom-textfield"
                                                disabled={AllTextDisabled}
                                            />
                                            <FormControlLabel
                                                value="Card"
                                                control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                                                label={
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <CreditCardIcon
                                                            sx={{
                                                                fontSize: 18,
                                                                marginRight: 0.2,
                                                                marginLeft: 0,
                                                                opacity: 0.7,
                                                                color: "rgba(0, 0, 0, 0.5)",
                                                            }}
                                                        />
                                                        Card
                                                    </div>
                                                }
                                                className="custom-textfield"
                                                disabled={AllTextDisabled}
                                            />
                                            <FormControlLabel
                                                value="RTGS/NEFT"
                                                control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                                                label={
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <PublishedWithChangesIcon
                                                            sx={{
                                                                fontSize: 18,
                                                                marginRight: 0.2,
                                                                marginLeft: 0,
                                                                opacity: 0.7,
                                                                color: "rgba(0, 0, 0, 0.5)",
                                                            }}
                                                        />
                                                        RTGS/NEFT
                                                    </div>
                                                }
                                                className="custom-textfield"
                                                disabled={AllTextDisabled}
                                            />
                                            <FormControlLabel
                                                value="Online"
                                                control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                                                label={
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <PublicIcon
                                                            sx={{
                                                                fontSize: 18,
                                                                marginRight: 0.2,
                                                                marginLeft: 0,
                                                                opacity: 0.7,
                                                                color: "rgba(0, 0, 0, 0.5)",
                                                            }}
                                                        />
                                                        Online
                                                    </div>
                                                }
                                                className="custom-textfield"
                                                disabled={AllTextDisabled}
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* Conditional Fields for Non-Cash Payment */}
                        {formData.Pyttype && formData.Pyttype !== "Cash" && (
                            <>
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                        fullWidth
                                        label={<span>Customer Bank<span style={{ color: "red" }}>*</span></span>}
                                        name="BankName"
                                        variant="filled"
                                        className="custom-textfield"
                                        disabled={AllTextDisabled}
                                        value={formData.BankName || ""}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                        fullWidth
                                        label={<span>Card No</span>}
                                        name="CardNo"
                                        variant="filled"
                                        className="custom-textfield"
                                        disabled={AllTextDisabled}
                                        value={formData.CardNo || ""}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                        fullWidth
                                        label={<span>Cheque No/Transaction Id<span style={{ color: "red" }}>*</span></span>}
                                        name="ChequeNo"
                                        variant="filled"
                                        className="custom-textfield"
                                        disabled={AllTextDisabled}
                                        value={formData.ChequeNo || ""}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                        fullWidth
                                        label={<span>Cheque Date/Transaction Date<span style={{ color: "red" }}>*</span></span>}
                                        name="ChqDt"
                                        variant="filled"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        className="custom-textfield"
                                        disabled={AllTextDisabled}
                                        value={formData.ChqDt ? moment(formData.ChqDt).format("YYYY-MM-DD") : currentDate}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                        fullWidth
                                        label="On Account Balance"
                                        name="OnacBal"
                                        variant="filled"
                                        className="custom-textfield"
                                        disabled
                                        value={formData.OnacBal !== undefined && formData.OnacBal !== null ? formData.OnacBal : ""}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                      <FormControl variant="filled" fullWidth className="custom-select">
                                <InputLabel id="AccLedId-select-label">
                                    Our Bank/Ledger <span style={{ color: "red" }}>*</span>
                                </InputLabel>
                                <Select
                                    labelId="AccLedId-select-label"
                                    id="AccLedId"
                                    name="AccLedId"
                                    value={formData.AccLedId || ""}
                                    onChange={handleFieldChange("AccLedId")}
                                    className="custom-textfield"
                                    disabled={AllTextDisabled}
                                >
                                    {formData.Pyttype === "Cash"
                                        ? bankData
                                            .filter((bank) => bank.Id === 1)
                                            .map((bank) => (
                                                <MenuItem key={bank.Id} value={bank.Id}>
                                                    {bank.Name}
                                                </MenuItem>
                                            ))
                                        : bankData
                                            .filter((bank) => bank.Id !== 1)
                                            .map((bank) => (
                                                <MenuItem key={bank.Id} value={bank.Id}>
                                                    {bank.Name}
                                                </MenuItem>
                                            ))}
                                </Select>
                            </FormControl>
                                </Grid>
                            </>
                        )}
{/* 
                        <Grid item xs={12} sm={6} md={12}>
                            <FormControl variant="filled" fullWidth className="custom-select">
                                <InputLabel id="AccLedId-select-label">
                                    Our Bank/Ledger <span style={{ color: "red" }}>*</span>
                                </InputLabel>
                                <Select
                                    labelId="AccLedId-select-label"
                                    id="AccLedId"
                                    name="AccLedId"
                                    value={formData.AccLedId || ""}
                                    onChange={handleFieldChange("AccLedId")}
                                    className="custom-textfield"
                                    disabled={AllTextDisabled}
                                >
                                    {formData.Pyttype === "Cash"
                                        ? bankData
                                            .filter((bank) => bank.Id === 1)
                                            .map((bank) => (
                                                <MenuItem key={bank.Id} value={bank.Id}>
                                                    {bank.Name}
                                                </MenuItem>
                                            ))
                                        : bankData
                                            .filter((bank) => bank.Id !== 1)
                                            .map((bank) => (
                                                <MenuItem key={bank.Id} value={bank.Id}>
                                                    {bank.Name}
                                                </MenuItem>
                                            ))}
                                </Select>
                            </FormControl>
                        </Grid> */}

                        {/* Payment For */}
                        <Grid item xs={8}>
                            <Grid container alignItems="center" spacing={1}>
                                <Grid item>
                                    <FormLabel component="legend">Payment For</FormLabel>
                                </Grid>
                                <Grid item>
                                    <FormControl component="fieldset">
                                        <RadioGroup
                                            aria-label="PytFlag"
                                            name="PytFlag"
                                            onChange={(e) => handleRadioChange("PytFlag", e.target.value)}
                                            value={formData.PytFlag || "D"}
                                            row
                                        >
                                            <FormControlLabel
                                                value="D"
                                                control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                                                label="Deposit"
                                                className="custom-textfield"
                                                disabled={AllTextDisabled}
                                            />
                                            <FormControlLabel
                                                value="R"
                                                control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                                                label="Other"
                                                className="custom-textfield"
                                                disabled={AllTextDisabled}
                                            />
                                            <FormControlLabel
                                                value="N"
                                                control={<Radio sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }} />}
                                                label="Cheque Return"
                                                className="custom-textfield"
                                                disabled={AllTextDisabled}
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                label={<span>Payment Amount <span style={{ color: "red" }}>*</span></span>}
                                name="PytAmt"
                                variant="filled"
                                className="custom-textfield"
                                disabled={AllTextDisabled}
                                value={formData.PytAmt !== undefined && formData.PytAmt !== null ? formData.PytAmt : ""}
                                onChange={handleInputChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                label="Against Bill Amount"
                                name="AgstBill"
                                variant="filled"
                                className="custom-textfield"
                                disabled
                                value={formData.AgstBill !== undefined && formData.AgstBill !== null ? formData.AgstBill : ""}
                                onChange={handleInputChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                label="On Account"
                                name="OnacAmt"
                                variant="filled"
                                className="custom-textfield"
                                disabled
                                value={formData.OnacAmt !== undefined && formData.OnacAmt !== null ? formData.OnacAmt : ""}
                                onChange={handleInputChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                label="On Account Balance"
                                name="OnacBal"
                                variant="filled"
                                className="custom-textfield"
                                disabled
                                value={formData.OnacBal !== undefined && formData.OnacBal !== null ? formData.OnacBal : ""}
                                onChange={handleInputChange}
                            />
                        </Grid>

                        {/* Remark */}
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={<span>Remark</span>}
                                name="Remark"
                                variant="filled"
                                className="custom-textfield"
                                disabled={AllTextDisabled}
                                value={formData.Remark || ""}
                                onChange={handleInputChange}
                            />
                        </Grid>
                    </Grid>

                    {/* Form Buttons */}
                    <Grid item xs={12} className="form_button" >
                        <Button
                            variant="contained"
                            size="small"
                            sx={{
                                mr: 1,
                                background: "#064c97ff",
                                color: '#fff'
                            }}
                            disabled={AllTextDisabled}
                            onClick={handleNextButtonClick}
                        >
                            Next
                        </Button>

                        <Button
                            variant="contained"
                            size="small"
                            disabled={AllTextDisabled}
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    );
};

export default RefundStep1;